import { useCallback } from 'react';
import { Typography } from '@creditas-ui/react';
import { Checkmark } from '~/components/Icons';
import { StepperContainer, StepperItem, StepperCount, StepperLine } from './Stepper.style';

type StepperProps = {
  title?: string;
  totalSteps: number;
  currentStep: number;
  hasNext: boolean;
};

const Stepper = ({ title, totalSteps, currentStep, hasNext }: StepperProps): JSX.Element => {
  const steps = Array.from({ length: totalSteps ?? 0 });

  const countClassName = useCallback(
    (currentIndex: number) => {
      if (currentIndex < currentStep) return 'checked';

      return currentIndex === currentStep ? 'active' : 'disabled';
    },
    [currentStep],
  );

  return (
    <StepperContainer>
      {steps.map((_, index) => {
        const currentIndex = index + 1;

        const label = countClassName(currentIndex) === 'checked' ? <Checkmark /> : currentIndex;

        return (
          <StepperItem key={currentIndex}>
            <StepperCount className={countClassName(currentIndex)}>
              <Typography variant="bodySmRegular">{label}</Typography>
            </StepperCount>
            {currentIndex === currentStep && (
              <>
                <Typography variant="bodySmMedium">{title}</Typography>
                {hasNext && <StepperLine />}
              </>
            )}
          </StepperItem>
        );
      })}
    </StepperContainer>
  );
};

export { Stepper };
